/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React, {useEffect} from "react";
import LayoutFullWidth from "@/app/components/layouts/LayoutFullWidth";
import {useTranslation} from "next-i18next";
import useGetCmsBlock from "@/app/connector/pageBuilder/getCmsBlock";
import NoRouteSkeleton from "@/app/components/NoRoute/NoRouteSkeleton";
import classes from "@/app/components/NoRoute/404-styles.module.scss"
import {FullPageLoader} from "@/app/components/common/FullPageLoader";

export default function NoRoute(props: {
    loading? :boolean // Because of specify of process switching stores and possibility of existing page only on one store
                      // we need to prevent showing 404 page content during stores switching process
                      // that's why we need this property to show loading spinner during switching stores process
                      // instead of showing 404 page content
}) {
    const {t} = useTranslation();
    const {getCmsBlockTrigger, loading, cmsBlockContent, cmsBlockData} = useGetCmsBlock(<NoRouteSkeleton />);

    useEffect(() => {
        getCmsBlockTrigger('404-page-not-found');
    }, [getCmsBlockTrigger]);

    const metaTitle = !loading && cmsBlockData.title ? cmsBlockData.title : t('404 - Page not found');
    const metaDescription = t('Page 404 - no route');

    return <LayoutFullWidth
        headTitle={metaTitle}
        metaDescription={metaDescription ?? metaTitle}
        mainContainerClassName={`${classes['page-404']}`}
    >
        {!props.loading ? cmsBlockContent : <FullPageLoader />}
    </LayoutFullWidth>;
}